module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": "60%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": "",
      "content-class": "elevation-0"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('v-card', {
    staticClass: "rounded-xl"
  }, [(_vm.selectRechnung.rechnung_titel) ? _c('v-card-title', [(_vm.selectRechnung.status === 'Gezahlt') ? _c('v-chip', {
    staticClass: "green mr-2",
    attrs: {
      "small": "",
      "dark": "",
      "label": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.selectRechnung.status) + "\n      ")]) : _c('v-chip', {
    staticClass: "red mr-2",
    attrs: {
      "small": "",
      "dark": "",
      "label": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.selectRechnung.status) + "\n      ")]), _vm._v("\n      " + _vm._s(_vm.selectRechnung.rechnung_titel) + "\n      "), _c('v-spacer'), _vm._v(" "), (_vm.selectRechnung.status !== 'Entwurf' && _vm.selectRechnung.status !== 'Entwurf SEPA') ? _c('buttonRechnungDownload', {
    staticClass: "hidden-xs-only",
    attrs: {
      "small": true,
      "icon": "download",
      "rechnung": _vm.selectRechnung
    }
  }) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "hidden-xs-only",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "ma-0 pa-0"
  }, [(_vm.selectRechnung.log) ? _c('v-alert', {
    staticClass: "ma-3",
    attrs: {
      "outlined": "",
      "color": "primary",
      "dismissible": ""
    }
  }, [_c('span', {
    staticClass: "text-subtitle-2"
  }, [_vm._v("Rechnung wurde " + _vm._s(_vm.selectRechnung.log.filter(function (item) { return item.type === "Mailversand"; }).length) + " mal per Mail\n          zugestellt.")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.selectRechnung.log.filter(function (item) { return item.type === 'Mailversand'; }).length > 0) ? _c('span', {
    staticClass: "text-caption"
  }, [_vm._v("Zuletzt versendet:\n          " + _vm._s(_vm.$filters.date(
    _vm.selectRechnung.log.filter(function (item) { return item.type === "Mailversand"; }).slice(-1)[0].date.seconds * 1000,
    "DD.MM.YYYYhhmm"
  )) + "\n          Uhr")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('v-row', {
    staticClass: "ma-0 pa-0 hidden-xs-only mt-n1"
  }, [_c('v-col', {
    staticClass: "d-flex justify-end mb-n16",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-img', {
    staticClass: "mb-n16",
    attrs: {
      "src": _vm.logoUrl,
      "height": "256px",
      "max-width": "256px"
    },
    scopedSlots: _vm._u([{
      key: "placeholder",
      fn: function() {
        return [_c('v-row', {
          staticClass: "fill-height ma-0",
          attrs: {
            "align": "center",
            "justify": "center"
          }
        }, [_c('v-progress-circular', {
          attrs: {
            "indeterminate": ""
          }
        })], 1)]
      },
      proxy: true
    }])
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-0 mt-12",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-sheet', {
    staticClass: "primary",
    attrs: {
      "height": "4"
    }
  }), _vm._v(" "), (_vm.$vars.verbindung !== 'gfsm') ? _c('v-sheet', {
    staticClass: "secondary",
    attrs: {
      "height": "4"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$vars.verbindung !== 'gfsm') ? _c('v-sheet', {
    staticClass: "tertiary",
    attrs: {
      "height": "4"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.settings) ? _c('v-col', {
    staticClass: "mt-n4 mb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('span', {
    staticClass: "caption font-weight-bold"
  }, [_vm._v(_vm._s(_vm.settings.name))]), _vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("| " + _vm._s(_vm.settings.strasse) + " " + _vm._s(_vm.settings.hausnummer) + " | " + _vm._s(_vm.settings.plz) + " " + _vm._s(_vm.settings.ort))])]) : _vm._e()], 1), _vm._v(" "), _c('v-row', {
    staticClass: "ma-0 pa-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "4",
      "md": "2"
    }
  }, [_c('span', {
    staticClass: "caption font-weight-bold"
  }, [_vm._v("Rechnungsnr.")]), _c('br'), _vm._v(" "), (_vm.selectRechnung.rechnungsnummer) ? _c('span', [_vm._v(_vm._s(_vm.selectRechnung.rechnungsnummer))]) : _vm._e(), _c('br')]), _vm._v(" "), (_vm.selectRechnung.rechnung_datum) ? _c('v-col', {
    attrs: {
      "cols": "4",
      "md": "2"
    }
  }, [_c('span', {
    staticClass: "caption font-weight-bold"
  }, [_vm._v("Rechnungsdatum")]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$filters.date(_vm.selectRechnung.rechnung_datum, "DD.MM.YYYY")))]), _c('br')]) : _vm._e(), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4",
      "md": "2"
    }
  }, [_c('span', {
    staticClass: "caption font-weight-bold"
  }, [_vm._v("Zahlbar bis")]), _c('br'), _vm._v(" "), (_vm.selectRechnung.rechnung_zahlbar_bis) ? _c('span', [_vm._v(_vm._s(_vm.$filters.date(_vm.selectRechnung.rechnung_zahlbar_bis, "DD.MM.YYYY")))]) : _vm._e(), _c('br')]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4",
      "md": "2"
    }
  }, [_c('span', {
    staticClass: "caption font-weight-bold"
  }, [_vm._v("Kasse")]), _c('br'), _vm._v(" "), (_vm.selectRechnung.kasse) ? _c('span', [_vm._v(_vm._s(_vm.selectRechnung.kasse))]) : _vm._e(), _c('br')]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4",
      "md": "2"
    }
  }, [_c('span', {
    staticClass: "caption font-weight-bold"
  }, [_vm._v("Rechnungsart")]), _c('br'), _vm._v(" "), (_vm.selectRechnung.rechnung_art) ? _c('span', [_vm._v(_vm._s(_vm.selectRechnung.rechnung_art))]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4",
      "md": "2"
    }
  }, [_c('span', {
    staticClass: "caption font-weight-bold"
  }, [_vm._v("Gezahlt am")]), _c('br'), _vm._v(" "), (_vm.selectRechnung.gezahlt_datum) ? _c('span', [_vm._v(_vm._s(_vm.$filters.date(_vm.selectRechnung.gezahlt_datum, "DD.MM.YYYY")))]) : _vm._e(), _c('br')])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [(_vm.selectRechnung.rechnung_freitext) ? _c('v-textarea', {
    staticClass: "pa-1",
    attrs: {
      "readonly": "",
      "solo": "",
      "flat": "",
      "auto-grow": "",
      "max-rows": "15"
    },
    model: {
      value: (_vm.selectRechnung.rechnung_freitext),
      callback: function($$v) {
        _vm.$set(_vm.selectRechnung, "rechnung_freitext", $$v)
      },
      expression: "selectRechnung.rechnung_freitext"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.selectRechnung.positionen) ? _c('v-expansion-panels', {
    staticClass: "ma-0 pt-0 pb-0",
    attrs: {
      "flat": "",
      "accordion": "",
      "multiple": ""
    }
  }, [_vm._l((_vm.selectRechnung.positionen), function(item, itemObjKey) {
    return _c('v-expansion-panel', {
      key: item.name,
      attrs: {
        "readonly": !item.positionen.length > 0
      }
    }, [_c('v-divider'), _vm._v(" "), _c('v-expansion-panel-header', {
      attrs: {
        "hide-actions": !item.positionen.length > 0
      },
      scopedSlots: _vm._u([{
        key: "actions",
        fn: function() {
          return [_c('v-icon', [_vm._v("keyboard_arrow_down")])]
        },
        proxy: true
      }], null, true)
    }, [_vm._v(_vm._s(itemObjKey + 1) + "\n            "), _c('span', {
      staticClass: "pl-3"
    }, [_vm._v("\n              " + _vm._s(item.was) + "\n            ")]), _vm._v(" "), _c('span', {
      staticClass: "text-right pr-4"
    }, [_vm._v("\n              " + _vm._s(_vm._f("money")(item.betrag)) + "\n            ")])]), _vm._v(" "), (item.positionen) ? _c('v-expansion-panel-content', [(item.was === 'EKP') ? _c('v-card', {
      attrs: {
        "outlined": ""
      }
    }, [_c('v-card-title', {
      staticClass: "overline py-0"
    }, [_vm._v("Zusammenfassung")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-simple-table', {
      attrs: {
        "dense": "",
        "fixed-header": ""
      }
    }, [_c('tbody', _vm._l((item.result), function(item) {
      return _c('tr', {
        key: item.name
      }, [_c('th', {
        attrs: {
          "width": "30px"
        }
      }, [_vm._v(_vm._s(item.anzahl) + "x")]), _vm._v(" "), (item.was) ? _c('th', [_vm._v(_vm._s(item.was))]) : _vm._e(), _vm._v(" "), _c('th', {
        staticClass: "text-right"
      }, [_vm._v(_vm._s(_vm._f("money")(item.preis)))])])
    }), 0)])], 1) : _vm._e(), _vm._v(" "), _c('v-card', {
      staticClass: "mt-2",
      attrs: {
        "outlined": ""
      }
    }, [(item.was === 'EKP') ? _c('v-card-title', {
      staticClass: "overline py-0"
    }, [_vm._v("Einzelauflistung")]) : _vm._e(), _vm._v(" "), (item.was === 'EKP') ? _c('v-divider') : _vm._e(), _vm._v(" "), _c('v-simple-table', {
      attrs: {
        "dense": "",
        "fixed-header": ""
      }
    }, [_c('tbody', _vm._l((item.positionen), function(item) {
      return _c('tr', {
        key: item.name
      }, [_c('td', {
        attrs: {
          "width": "130px"
        }
      }, [_vm._v(_vm._s(_vm.$filters.date(item.datum, "DD.MM.YYYY")))]), _vm._v(" "), (item.anzahl !== undefined) ? _c('td', [_vm._v(_vm._s(item.anzahl))]) : _vm._e(), _vm._v(" "), (item.was) ? _c('td', [_vm._v(_vm._s(item.was))]) : _vm._e(), _vm._v(" "), _c('td', {
        staticClass: "text-right"
      }, [_vm._v(_vm._s(_vm._f("money")(item.preis)))])])
    }), 0)])], 1)], 1) : _vm._e()], 1)
  }), _vm._v(" "), _c('v-expansion-panel', {
    attrs: {
      "readonly": ""
    }
  }, [_c('v-divider'), _vm._v(" "), _c('v-expansion-panel-header', {
    attrs: {
      "hide-actions": ""
    }
  }, [_c('span', {
    staticClass: "text-right pr-4 font-weight-bold"
  }, [_vm._v("\n              " + _vm._s(_vm._f("money")(_vm.selectRechnung.summe)) + "\n            ")])])], 1)], 2) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
    staticClass: "mb-6 mb-md-0"
  }, [(_vm.allowRechnungBearbeiten) ? _c('v-btn', {
    staticClass: "hidden-xs-only",
    attrs: {
      "rounded": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        (_vm.showBearbeiten = true) && (_vm.bearbeiteRechnung = JSON.parse(JSON.stringify(_vm.selectRechnung)))
      }
    }
  }, [_vm._v("Bearbeiten")]) : _vm._e(), _vm._v(" "), (_vm.selectRechnung.status !== 'Entwurf' && _vm.selectRechnung.status !== 'Entwurf SEPA') ? _c('buttonRechnungSenden', {
    attrs: {
      "small": false,
      "icon": "outgoing_mail",
      "text": "Per Mail senden",
      "rechnung": _vm.selectRechnung
    }
  }) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.allowRechnungBearbeiten && _vm.selectRechnung.status !== 'Gezahlt') ? _c('v-btn', {
    staticClass: "green",
    attrs: {
      "rounded": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        return _vm.neuerStatus(_vm.selectRechnung, 'Gezahlt')
      }
    }
  }, [_vm._v("Als Gezahlt markieren")]) : _vm._e(), _vm._v(" "), (
    (_vm.selectRechnung.status === 'Überfällig' || _vm.selectRechnung.status === 'Gemahnt überfällig') &&
    _vm.allowRechnungBearbeiten
  ) ? _c('v-btn', {
    staticClass: "red",
    attrs: {
      "rounded": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.showMahnung = true
      }
    }
  }, [_vm._v("Mahnen")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "rounded": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Schließen")])], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "60%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showBearbeiten),
      callback: function($$v) {
        _vm.showBearbeiten = $$v
      },
      expression: "showBearbeiten"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('v-chip', {
    staticClass: "mr-2",
    attrs: {
      "color": "green",
      "label": "",
      "dark": ""
    }
  }, [_vm._v("Chargenansicht")]), _vm._v("\n        Rechnung " + _vm._s(_vm.bearbeiteRechnung.rechnungsnummer) + " bearbeiten\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showBearbeiten = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-8 text-center subtitle-1"
  }, [_c('v-row', {
    staticClass: "ma-0 pa-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "type": "text",
      "label": "Titel"
    },
    model: {
      value: (_vm.bearbeiteRechnung.rechnung_titel),
      callback: function($$v) {
        _vm.$set(_vm.bearbeiteRechnung, "rechnung_titel", $$v)
      },
      expression: "bearbeiteRechnung.rechnung_titel"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-select', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "items": _vm.selectBbrBbr,
      "label": "Empfänger",
      "disabled": ""
    },
    model: {
      value: (_vm.bearbeiteRechnung.bbrID),
      callback: function($$v) {
        _vm.$set(_vm.bearbeiteRechnung, "bbrID", $$v)
      },
      expression: "bearbeiteRechnung.bbrID"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "type": "text",
      "label": "Rechnungsnummer",
      "disabled": ""
    },
    model: {
      value: (_vm.bearbeiteRechnung.rechnungsnummer),
      callback: function($$v) {
        _vm.$set(_vm.bearbeiteRechnung, "rechnungsnummer", $$v)
      },
      expression: "bearbeiteRechnung.rechnungsnummer"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "type": "date",
      "label": "Rechnungsdatum"
    },
    model: {
      value: (_vm.bearbeiteRechnung.rechnung_datum),
      callback: function($$v) {
        _vm.$set(_vm.bearbeiteRechnung, "rechnung_datum", $$v)
      },
      expression: "bearbeiteRechnung.rechnung_datum"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "type": "date",
      "label": "Zahlbar bis"
    },
    model: {
      value: (_vm.bearbeiteRechnung.rechnung_zahlbar_bis),
      callback: function($$v) {
        _vm.$set(_vm.bearbeiteRechnung, "rechnung_zahlbar_bis", $$v)
      },
      expression: "bearbeiteRechnung.rechnung_zahlbar_bis"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-select', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "items": _vm.statusItems,
      "label": "Status"
    },
    model: {
      value: (_vm.bearbeiteRechnung.status),
      callback: function($$v) {
        _vm.$set(_vm.bearbeiteRechnung, "status", $$v)
      },
      expression: "bearbeiteRechnung.status"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "rows": "8",
      "type": "text",
      "label": "Text"
    },
    model: {
      value: (_vm.bearbeiteRechnung.rechnung_freitext),
      callback: function($$v) {
        _vm.$set(_vm.bearbeiteRechnung, "rechnung_freitext", $$v)
      },
      expression: "bearbeiteRechnung.rechnung_freitext"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-simple-table', {
    attrs: {
      "dense": "",
      "fixed-header": ""
    }
  }, [_c('tbody', [_vm._l((_vm.bearbeiteRechnung.positionen), function(item, itemObjKey) {
    return _c('tr', {
      key: itemObjKey
    }, [_c('td', {
      attrs: {
        "width": "20px"
      }
    }, [_vm._v(_vm._s(itemObjKey + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(item.was))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("money")(item.betrag)))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "20px"
      }
    }, [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          (_vm.showEditPosition = true) && (_vm.neuePosition = item) && (_vm.selectedPositionIndex = itemObjKey)
        }
      }
    }, [_c('v-icon', [_vm._v("edit")])], 1)], 1)])
  }), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "20px"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }), _vm._v(" "), _c('td', {
    staticClass: "text-right pr-4 font-weight-bold"
  }, [_vm._v(_vm._s(_vm._f("money")(_vm.bearbeiteRechnung.summe)))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "20px"
    }
  })])], 2)])], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_vm._v("Positionen können nur bearbeitet aber nicht hinzugefügt werden.")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
    staticClass: "mb-6 mb-md-0"
  }, [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showBearbeiten = false
      }
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "dark": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.updateRechnungData()
      }
    }
  }, [_vm._v("speichern")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "50%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showEditPosition),
      callback: function($$v) {
        _vm.showEditPosition = $$v
      },
      expression: "showEditPosition"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("\n        Position bearbeiten\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showEditPosition = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-4"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "type": "text",
      "label": "Bezeichnung"
    },
    model: {
      value: (_vm.neuePosition.was),
      callback: function($$v) {
        _vm.$set(_vm.neuePosition, "was", $$v)
      },
      expression: "neuePosition.was"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [(_vm.neuePosition.positionen.length === 0) ? _c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "type": "number",
      "label": "Betrag"
    },
    model: {
      value: (_vm.neuePosition.betrag),
      callback: function($$v) {
        _vm.$set(_vm.neuePosition, "betrag", $$v)
      },
      expression: "neuePosition.betrag"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.neuePosition.positionen.length > 0) ? _c('v-data-table', {
    attrs: {
      "items-per-page": _vm.neuePosition.positionen.length,
      "dense": "",
      "fixed-header": "",
      "height": "290",
      "hide-default-footer": "",
      "items": _vm.neuePosition.positionen,
      "headers": _vm.headersData
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(ref) {
        var item = ref.item;
        var index = ref.index;

        return [_c('tr', [_c('td', {
          attrs: {
            "width": "20px"
          }
        }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_c('v-text-field', {
          staticClass: "text-right",
          attrs: {
            "dense": "",
            "hide-details": "",
            "label": "Bezeichnung",
            "single-line": "",
            "solo": "",
            "flat": "",
            "reverse": ""
          },
          model: {
            value: (item.was),
            callback: function($$v) {
              _vm.$set(item, "was", $$v)
            },
            expression: "item.was"
          }
        })], 1), _vm._v(" "), _c('td', {
          attrs: {
            "width": "120px"
          }
        }, [_vm._v(_vm._s(_vm.$filters.date(item.datum.seconds * 1000)))]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "120px"
          }
        }, [_c('v-text-field', {
          staticClass: "text-right",
          attrs: {
            "dense": "",
            "hide-details": "",
            "prefix": "€",
            "label": "Betrag",
            "single-line": "",
            "solo": "",
            "flat": "",
            "reverse": ""
          },
          model: {
            value: (item.preis),
            callback: function($$v) {
              _vm.$set(item, "preis", $$v)
            },
            expression: "item.preis"
          }
        })], 1), _vm._v(" "), _c('td', {
          attrs: {
            "width": "20px"
          }
        })])]
      }
    }], null, false, 1897472944)
  }) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
    staticClass: "mb-6 mb-md-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('span', {
    staticClass: "pr-4 font-weight-bold"
  }, [_vm._v("Summe: " + _vm._s(_vm._f("money")(_vm.summePosition)))]), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.savePosition()
      }
    }
  }, [_vm._v("Speichern")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "50%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showMahnung),
      callback: function($$v) {
        _vm.showMahnung = $$v
      },
      expression: "showMahnung"
    }
  }, [_c('v-card', [(_vm.selectRechnung.rechnungsnummer) ? _c('v-card-title', [_vm._v("\n        Rechnung mahnen\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showMahnung = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('v-row', [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-checkbox', {
    attrs: {
      "on-icon": "check_box",
      "off-icon": "check_box_outline_blank",
      "label": "Mahngebühr hinzufügen?"
    },
    model: {
      value: (_vm.selectMahngebuehr),
      callback: function($$v) {
        _vm.selectMahngebuehr = $$v
      },
      expression: "selectMahngebuehr"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "outlined": "",
      "type": "number",
      "label": "Betrag"
    },
    model: {
      value: (_vm.wertMahngebuehr),
      callback: function($$v) {
        _vm.wertMahngebuehr = $$v
      },
      expression: "wertMahngebuehr"
    }
  })], 1), _vm._v(" "), (_vm.selectMahngebuehr) ? _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-radio-group', {
    attrs: {
      "column": ""
    },
    model: {
      value: (_vm.artMahngebuehr),
      callback: function($$v) {
        _vm.artMahngebuehr = $$v
      },
      expression: "artMahngebuehr"
    }
  }, [_c('v-radio', {
    attrs: {
      "on-icon": "check_box",
      "off-icon": "check_box_outline_blank",
      "label": "Betrag",
      "value": "Betrag"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "on-icon": "check_box",
      "off-icon": "check_box_outline_blank",
      "label": "Prozent",
      "value": "Prozent"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "outlined": "",
      "type": "text",
      "label": "Zahlbar bis",
      "hint": "Format: 2022-03-21, Standart in 14 Tagen"
    },
    model: {
      value: (_vm.mahnungUpdateData.rechnung_zahlbar_bis),
      callback: function($$v) {
        _vm.$set(_vm.mahnungUpdateData, "rechnung_zahlbar_bis", $$v)
      },
      expression: "mahnungUpdateData.rechnung_zahlbar_bis"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "dense": "",
      "rows": "3",
      "label": "Freitext",
      "hint": "<<Rechnungstitel>>, <<Rechnungsdatum>>, <<Rechnungsnummer>>, <<Mahnstufe>>, <<Briefanrede>>, <<Vorname>>, <<Nachname>>, <<Rechnungsbetrag>>, <<Zahlbar_bis>>",
      "auto-grow": "",
      "outlined": ""
    },
    model: {
      value: (_vm.mahnungUpdateData.rechnung_freitext),
      callback: function($$v) {
        _vm.$set(_vm.mahnungUpdateData, "rechnung_freitext", $$v)
      },
      expression: "mahnungUpdateData.rechnung_freitext"
    }
  })], 1), _vm._v(" "), (_vm.selectMahngebuehr) ? _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_vm._v("\n            Der Rechnung wird eine weitere Position hinzugefügt."), _c('br'), _vm._v("\n            Mahngebühr: " + _vm._s(_vm.wertMahngebuehr) + " "), (_vm.artMahngebuehr === 'Betrag') ? _c('span', [_vm._v("€")]) : _vm._e(), (_vm.artMahngebuehr === 'Prozent') ? _c('span', [_vm._v("%")]) : _vm._e()]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
    staticClass: "mb-6 mb-md-0"
  }, [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showMahnung = false
      }
    }
  }, [_vm._v("Schließen")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "red",
    on: {
      "click": function($event) {
        return _vm.mahnen(_vm.selectRechnung)
      }
    }
  }, [_vm._v("Mahnen")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ea7ea86"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/submodule/dialogRechnung.vue
// module id = 752
// module chunks = 15